import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { NgForm, FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-user-forget-passowrd',
  templateUrl: './user-forget-passowrd.component.html',
  styleUrls: ['./user-forget-passowrd.component.scss']
})
export class UserForgetPassowrdComponent implements OnInit {
  forgetPasswordForm:FormGroup;
  flag:Boolean=false;
  public errorMessage ='';
  public emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';

  constructor(private userService:UserService ,private router:Router,private formBuilder:FormBuilder) { }

  ngOnInit() {


    $(document).ready(function() {
      $('input').attr('autocomplete', 'off');
      // setTimeout(function() {
      //   $('input').html('');
      // }, 100);
    });
    this.forgetPasswordFormModal();

  }
  EventClear(){
    this.errorMessage='';
  }
  public forgetPasswordFormModal(){
    this.forgetPasswordForm=this.formBuilder.group({
      emailId:['',[Validators.required,Validators.pattern(this.emailRegex)]]
    })
    
  }

 public forgetPassword(){
  this.errorMessage='';
  if(this.forgetPasswordForm.valid){
    this.userService.checkMailValidator(this.emailId.value).subscribe(response => {
      
      if(response.status!='success'){
        this.flag=false;
      } if(response.status==='success'){
        this.flag=true;
      }
    },error=>{
      this.flag=false;
      this.errorMessage='*'+error.error.message+'.';
    })
  }
  }
  protected get emailId(): AbstractControl {
    return this.forgetPasswordForm.get('emailId');
  }


  }





// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-forget-passowrd/user-forget-passowrd.component.ts